import SearchOffOutlined from '@mui/icons-material/SearchOffOutlined';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

export function TableEmptyState({ children }: { children?: ReactNode }): ReactNode {
  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        height: '100%',
        justifyContent: 'center',
        textAlign: 'center',
        width: '100%',
      }}
    >
      <SearchOffOutlined sx={{ color: 'text.disabled', fontSize: 32 }} />
      <Typography color="text.secondary">{children}</Typography>
    </Box>
  );
}
